export enum TextTrackModes {
	DISABLED = 'disabled',
	HIDDEN = 'hidden',
	SHOWING = 'showing'
}
